import TimeLineDataInterface from "../interface/timeline";

const parcours: TimeLineDataInterface[] = [];

export default parcours;
